import type { FC } from "react";
import React from "react";
import { useBrand, useTranslation } from "@edreamsodigeo/frontend-core";
import {
  Body,
  Box,
  Flex,
  Glyph,
  Heading,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@edreamsodigeo/prisma-design-system";

import { LightboxPill } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxPill";
import { tableCellsContent } from "./constants";
import {
  cellFirstColumnStyles,
  cellLastColumnStyles,
  cellLastColumnTopStyles,
  cellStyles,
  cellFooterTitleStyles,
  cellStylesHeader,
  cellFooterTextStyle,
} from "./styles";

const LightboxSavingsTable: FC = () => {
  const { t } = useTranslation();
  const isEdreams = useBrand() === "ED";
  return (
    <>
      <Box mb={"base"}>
        <Heading type={"6"} color={"neutral.80"}>
          {t("lightboxPrimeRevampDesktop.table.section.subtitle")}
        </Heading>
      </Box>
      <Box mt={"base"}>
        <Box
          pt={"1x_small"}
          pb={"base"}
          pl={"1x_small"}
          borderRadius={"regular"}
          backgroundColor={"primary.70"}
        >
          <Body
            type={"xSmall"}
            color={isEdreams ? "secondary.50" : "neutral.0"}
          >
            {t("lightboxPrimeRevampDesktop.table.title").toUpperCase()}
          </Body>
        </Box>
        <Box
          mt={"minus_1x_small"}
          borderWidth={"1px"}
          borderStyle={"solid"}
          borderColor={"neutral.30"}
          borderRadius={"regular"}
          backgroundColor={"neutral.0"}
        >
          <Table>
            <TableHead fontSize={"body.0"}>
              <TableRow hasBorderTop={false}>
                <TableHeader></TableHeader>
                <TableHeader textAlign={"left"} sx={cellStylesHeader}>
                  {t(
                    "lightboxPrimeRevampDesktop.table.col.one.mobile.title",
                  ).toUpperCase()}
                </TableHeader>
                <TableHeader textAlign={"left"} sx={cellStylesHeader}>
                  {t(
                    "lightboxPrimeRevampDesktop.table.col.two.mobile.title",
                  ).toUpperCase()}
                </TableHeader>
                <TableHeader textAlign={"left"} sx={cellLastColumnTopStyles}>
                  <Body type={"xSmall"} weight={"medium"}>
                    {t(
                      "lightboxPrimeRevampDesktop.table.col.three.mobile.title",
                    ).toUpperCase()}
                  </Body>
                </TableHeader>
              </TableRow>
            </TableHead>
            <TableBody fontSize={"body.0"}>
              {tableCellsContent.map((cellContent) => (
                <TableRow key={`table-row-${cellContent.type}`}>
                  <TableCell sx={cellFirstColumnStyles}>
                    <Flex flexWrap={"wrap"} alignItems={"center"}>
                      <Box mr={"2x_small"}>
                        <Glyph
                          category={cellContent.icon.category}
                          name={cellContent.icon.name}
                        />
                      </Box>
                      {t(
                        `lightboxPrimeRevampDesktop.table.row.${cellContent.type}.title`,
                      )}
                    </Flex>
                  </TableCell>
                  <TableCell sx={cellStyles}>
                    {t(
                      `lightboxPrimeRevampDesktop.table.row.${cellContent.type}.col.one.text`,
                    )}
                  </TableCell>
                  <TableCell sx={cellStyles}>
                    {t(
                      `lightboxPrimeRevampDesktop.table.row.${cellContent.type}.col.two.text`,
                    )}
                  </TableCell>
                  <TableCell sx={cellLastColumnStyles}>
                    <Body type={"xSmall"} weight={"medium"}>
                      {t(
                        `lightboxPrimeRevampDesktop.table.row.${cellContent.type}.col.three.text`,
                      )}
                    </Body>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={3} sx={cellFooterTitleStyles}>
                  <Body type={"xSmall"} weight={"medium"}>
                    {t("lightboxPrimeRevampDesktop.table.footer.title")}
                  </Body>
                </TableCell>
                <TableCell sx={cellFooterTextStyle}>
                  <LightboxPill type={"deals"} rounded>
                    <Body type={"xSmall"} weight={"medium"}>
                      {t("lightboxPrimeRevampDesktop.table.footer.text")}
                    </Body>
                  </LightboxPill>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    </>
  );
};

export default LightboxSavingsTable;
